import "./EquityPortfolioImpactComponent.scss";
import template from "./EquityPortfolioImpactComponent.html";

export const MultiAccountEquityPortfolioImpact = "tfMultiAccountEquityPortfolioImpact";

export function multiAccountEquityPortfolioImpact() {
    return {
        template,
        bindings: {
            cashAfterTrade: "<",
            currentBalance: "<",
            feesAndBrokerage: "<",
            tradeFees: "<",
            totalCost: "<"
        },
        controllerAs: "ctrl",
        controller: () => {} // Dummy controller as there is no logic in there
    };
}
